export const viewFile = (url: string) => {
  window.open(url, '_blank');
};
